import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Orders() {
    const [orders, setOrders] = useState([]);
    useEffect(() => { api.get("/orders").then(r => setOrders(r.data)); }, []);
    return (
        <div className="max-w-[1200px] mx-auto px-4 md:px-10 py-10" data-testid="orders-page">
            <h1 className="font-display text-5xl md:text-7xl tracking-tighter mb-8">Orders</h1>
            {orders.length === 0 ? (
                <div className="border-2 border-black p-16 text-center font-mono text-sm">No orders yet.</div>
            ) : (
                <div className="space-y-3">
                    {orders.map(o => (
                        <Link key={o.id} to={`/order/${o.id}/confirmation`} data-testid={`order-row-${o.order_number}`} className="block border-2 border-black p-5 brutal-shadow bg-white">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                                <div>
                                    <div className="font-mono text-[10px] uppercase text-neutral-500">Order</div>
                                    <div className="font-display text-2xl">#{o.order_number}</div>
                                </div>
                                <div className="flex flex-wrap gap-6">
                                    <div><div className="font-mono text-[10px] uppercase text-neutral-500">Items</div><div className="font-mono">{o.items.length}</div></div>
                                    <div><div className="font-mono text-[10px] uppercase text-neutral-500">Total</div><div className="font-mono">₹{Math.round(o.total)}</div></div>
                                    <div><div className="font-mono text-[10px] uppercase text-neutral-500">Status</div><div className="font-mono uppercase text-[hsl(var(--accent))]">{o.status}</div></div>
                                    <div><div className="font-mono text-[10px] uppercase text-neutral-500">Placed</div><div className="font-mono">{new Date(o.created_at).toLocaleDateString()}</div></div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
